import { gql } from "@apollo/client/core";
import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import styled from "styled-components";

import BIMClass from "./BIMClass";
import SearchBIMClass from "./SearchBIMClass.graphql";
import { taxonomy } from "../../api";
import { FluidAccent } from "../../ui-kit";

export const Component = styled(BIMClass)`
    ${ FluidAccent }
`;

export function getID(entity) {
    return entity.id;
}

export const name = "BIMClass";

export function useSearch(token: string) {
    const [execute, { called, data, error, loading }] = useLazyQuery(
        gql(SearchBIMClass),
        {
            client: taxonomy,
            variables: {
                token,
            },
        },
    );

    useEffect(
        () => {
            if (token.length < 3) return;

            if (!called) {
                void execute();
            }
        },
        [called, token],
    );

    const [results, setResults] = useState(undefined);

    useEffect(
        () => {
            if (token.length > 2 && data) {
                setResults(
                    data.searchBimClasses
                );
            } else {
                setResults([]);
            }
        },
        [data, token],
    );

    return {
        error,
        loading,
        results,
    };
}
